import { DateTime } from "luxon";

const DEFAULT_DATE_FORMAT = "MM/dd/yy";

export const convertToDate = (date, format = DEFAULT_DATE_FORMAT) => {
  if ([undefined, null, ""].includes(date)) {
    return null;
  }

  return DateTime.fromFormat(date, format);
};

export const firstDayOfPreviousMonth = () =>
  DateTime.now().plus({ month: -1 }).set({ day: 1 }).toFormat(DEFAULT_DATE_FORMAT);

export const fromSQLToDate = (date) => {
  if ([undefined, null, ""].includes(date)) {
    return null;
  }

  return DateTime.fromSQL(date).toFormat(DEFAULT_DATE_FORMAT);
};
